import {
  SelectInput,
  type SelectInputProps,
} from "@repo/ui/components/Base/SelectInput";
import { useField, useFormikContext } from "formik";

interface FormikSelectProps extends Omit<SelectInputProps, "onValueChange"> {
  name: string;
}

export const FormikSelect = ({ ...props }: FormikSelectProps) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);
  return (
    <SelectInput
      {...field}
      {...props}
      onValueChange={(value) => setFieldValue(props.name, value)}
    />
  );
};
